import { createInertiaApp, type ResolvedComponent } from "@inertiajs/react"
import { type ReactNode, createElement } from "react"
import { createRoot } from "react-dom/client"
import { Theme } from "@radix-ui/themes"
import DefaultLayout from "../layouts/default"

import "@radix-ui/themes/styles.css"

const appName = (import.meta.env.VITE_APP_NAME ?? "Foodmark") as string

void createInertiaApp({
  title: (title) => `${title} - ${appName}`,

  resolve: (name) => {
    const pages = import.meta.glob<{ default: ResolvedComponent }>(
      "../pages/**/*.tsx",
      {
        eager: true,
      }
    )
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
    }

    page.default.layout ??= (page: ReactNode) =>
      createElement(DefaultLayout, null, page)

    return page
  },

  setup({ el, App, props }) {
    createRoot(el).render(
      createElement(
        Theme,
        {
          accentColor: "orange",
          grayColor: "sand",
          appearance: "light",
          panelBackground: "solid",
          radius: "medium",
        },
        createElement(App, props)
      )
    )
  },
}).catch((error) => {
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
    )
  }
})
